var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.links.length
    ? _c("div", { staticClass: "shop-toolbar-links" }, [
        _c(
          "div",
          { staticClass: "shop-toolbar-links__list" },
          _vm._l(_vm.links, function (link, index) {
            return _c(
              "a",
              {
                key: index,
                staticClass: "shop-toolbar-links__link",
                attrs: { href: link.url },
              },
              [_vm._v(_vm._s(link.text))]
            )
          }),
          0
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }